import React, { useState, useEffect  } from 'react';
import { Paper, IconButton, Typography, Box  } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { logo } from "../data/constants";
import fetchFromAPI  from "../data/fetchFromAPI.js";

import Videos from '../components/Videos.js';

export default function AxiosSearch(){

    const [searchTerm, setSearchTerm] = useState('music');
    const [videos, setVideos] = useState(null);
    //const navigate = useNavigate();
    
    useEffect(() => {
        fetchFromAPI(`search?q=${searchTerm}`)
          .then((data) => setVideos(data.items))
      }, [searchTerm]);
    
    const onhandleSubmit = (e) => {
    //   e.preventDefault();
    
    //   if (searchTerm) {
    //     navigate(`/search/${searchTerm}`);
    
    //     setSearchTerm('');
    //   }
    };

    return(
        <>
            <Paper
            component='form'
            onSubmit={onhandleSubmit}
            sx={{
                borderRadius: 20,
                border: '1px solid #e3e3e3',
                pl: 2,
                boxShadow: 'none',
                mr: { sm: 5 },
            }}
            >
            <img src={logo} alt="logo" height={26} />
            <input
                className='search-bar'
                placeholder='Search...'
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
            <IconButton type='submit' sx={{ p: '10px', color: 'red' }} aria-label='search'>
                <SearchIcon />
            </IconButton>
            </Paper>
            <Box p={2} minHeight="95vh">
            <Typography variant="h4" fontWeight={900}  color="green" mb={3} ml={{ sm: "100px"}}>
                Search Results for <span style={{ color: "#FC1503" }}>{searchTerm}</span> videos
            </Typography>
            <Box display="flex">
                <Box sx={{ mr: { sm: '100px' } }}/>
                {<Videos videos={videos} />}
            </Box>
            </Box>         
        </>

    )
}